import { DateValidationObject } from '../models/validate-date';

export function validateDate(age: number): DateValidationObject {
  const maxDate = new Date();
  const invalidDates = [];
  const minValidDate = new Date(
    maxDate.getFullYear() - 16,
    maxDate.getMonth(),
    maxDate.getDate()
  );
  minValidDate.setFullYear(maxDate.getFullYear() - age);
  for (let d = minValidDate; d <= maxDate; d.setDate(d.getDate() + 1)) {
    invalidDates.push(new Date(d));
  }
  return {
    maxDate: maxDate,
    invalidDates: invalidDates,
    minDate: minValidDate,
  };
}

export function formatDate(dateInput: string | Date): string {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date');
  }


  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}
